module.exports = "<brd-layout>\r\n  <div class=\"brd-content\" [ngClass]=\"{'portal': isPortal}\">\r\n    <div style=\"width: 100%; height: 100%\"\r\n         #reportContainer></div>\r\n  </div>  \r\n</brd-layout>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.component.html
// module id = ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.component.html
// module chunks = main